import Link from 'next/link';

import { Button } from '@nebo-team-dev/vobaza.ui.button/dist';
import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import StaticPagesMenu from '../components/StaticPages/Menu';

import styles from 'global/styles/Contacts.module.scss';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'Сборка',
    href: '/sborka',
  },
];

export default function Assembly() {
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className={`${styles.staticPage} container`}>
        <StaticPagesMenu />
        <div className={styles.staticPageContent}>
          <h1 className={styles.staticPageTitle}>Подъем</h1>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageTable}>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>
                  Малогабаритный товар не&nbsp;более 4х&nbsp;единиц (суммарно массой до&nbsp;25кг)
                </div>
                <div className={styles.staticPageTableCell}>Бесплатно</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>
                  Крупногабаритный или малогабаритный товар более 4х&nbsp;единиц или суммарно массой более 25кг
                  на&nbsp;лифте
                </div>
                <div className={styles.staticPageTableCell}>Бесплатно</div>
              </div>
              <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>Ручной подъем заказа (суммарно массой более 25кг)</div>
                <div className={styles.staticPageTableCell}>300&nbsp;₽/этаж</div>
              </div>
              {/* <div className={styles.staticPageTableRow}>
                <div className={styles.staticPageTableCell}>
                  Ручной подъем заказа при экспресс-доставке (суммарно массой более 25кг)
                </div>
                <div className={styles.staticPageTableCell}>400&nbsp;₽/этаж</div>
              </div> */}
            </div>
          </div>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageTitle}>Сборка</div>
            <div className={styles.staticPageText}>
              При оформлении услуги доставки и&nbsp;подъема мягкой мебели (в&nbsp;категории Диваны, Кушетки, Кресла)
              сборка этих категорий осуществляется бесплатно.
            </div>
            <div className={styles.staticPageText}>
              Стоимость сборки корпусной мебели составляет&nbsp;12% от&nbsp;стоимости мебели, но&nbsp;не&nbsp;менее
              1500&nbsp;₽. Корпусная мебель&nbsp;&mdash; это категории Шкаф, Кровать, Стол, Комод, Тумба, Стулья,
              Табурет.
            </div>
            <div className={styles.staticPageText}>
              Сборка кухонных гарнитуров – 12% от стоимости собираемой мебели, но не менее 2000 рублей. Дополнительные
              услуги типа: навеска верхних секций на стену, распил столешницы, установка оборудования и т.п.
              рассчитываются и оплачиваются отдельно сборщику в момент сборки кухонных модулей согласно прайс-листу на
              доп. услуги.
              <br />
              <br />
              Выезд сборщика за МКАД 40 руб/км.
            </div>
            <div className={styles.staticPageButtonsBlock}>
              <Link className={styles.staticPageInfo} href="/docs/sborka.pdf" target="_blank">
                <Button text="Условия для сборки" />
              </Link>
              <Link href="/docs/price.pdf" target="_blank">
                <Button text="Прайс-лист на дополнительные услуги" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
